import { render, staticRenderFns } from "./PromisedImage.vue?vue&type=template&id=37e5ffec&scoped=true&"
import script from "./PromisedImage.vue?vue&type=script&lang=ts&"
export * from "./PromisedImage.vue?vue&type=script&lang=ts&"
import style0 from "./PromisedImage.vue?vue&type=style&index=0&id=37e5ffec&lang=scss&scoped=true&"
import style1 from "./PromisedImage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e5ffec",
  null
  
)

export default component.exports